import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Progress, Row, Col, Table, Button } from 'reactstrap';
import { Link } from 'react-router'

import Loader from '../../core/components/Loader'
import '../styles/leads.css'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

import { renderIconSpecialties } from '../../provider/utils'
import { capitalizeFirstLetter } from '../../utils/parse'

import IconList from 'react-icons/lib/fa/list'
import IconFilter from 'react-icons/lib/fa/filter'

class LeadList extends React.Component {

    constructor(props) {
	    super(props);
	    this.changeResponsiveStatus = this.changeResponsiveStatus.bind(this)

	    this.state = {
	    	order: 'desc',
	    	display: 'tunnel',
	    	lead: 'lead',
	    	responsive:'CA'
	    };
	    this.options = {
	      hideSizePerPage:true
	    };
	}

	componentDidMount() {
	    this.props.listLead(this.props.date);
	    if( window.innerWidth < 520)
	    	this.setState({display:'responsive'})
	}

	leadRefusal(event) {
		if(event.target.checked){
			this.props.listRefusal();
			this.setState({lead:'refusal'})
		}
		else{
			this.props.listLead();
			this.setState({lead:'lead'})
		}
	}

	changeDisplay(display){
		this.setState({display});
		if(display === "tunnel" && this.state.lead === 'refusal'){
			this.props.listLead();
			this.setState({lead:'lead'})
		}
	}

	companyFormatter(cell, row, enumObject, index) {
		return (
			<div className="company-formatter">
			    <Link to={"/manager/prestataire/"+row.id} ><div className="company"> {capitalizeFirstLetter(row.company)} </div></Link>
          		<Link to={"/manager/prestataire/"+row.id} ><div className="name"> {capitalizeFirstLetter(row.first_name)} {capitalizeFirstLetter(row.last_name)} </div></Link>
			</div>
		);
	}

	regionFormatter(cell, row, enumObject, index) {
		return (
			<div className="region-formatter">
			    <div className="region"> {row.region_name} </div>
			    <div className="departments"> {row.list_departments.join('-')} </div>
			</div>
		);
	}

	cpFormatter(cell, row, enumObject, index) {
		return (
			<div className="cp-formatter">{row.zip}</div>
		);
	}

	specialtiesFormatter(cell, row, enumObject, index) {
		return (
			<div className="specialties-formatter">
			    {renderIconSpecialties(cell)}
			</div>
		);
	}

	statusFormatter(cell, row, enumObject, index) {
		var status = {
    		CA: 'Candidature',
    		RV: 'Rendez-vous',
    		PA: 'Pré-analyse',
    		W: 'Stand-By',
    		A: 'Approuvé',
    		R: 'Refusé'
    	};
		return (
			<span className="status-formatter">
				{status[cell]}
			</span>
		);
	}

	percentageFormatter(cell, row, enumObject, index) {
		return (
			<div className="percentage-formatter">
				<div className="progress-bloc"> <Progress color={cell === 100 ? 'success' : cell < 75 ? 'danger' : 'info'} value={cell} /> </div>
				<div className={"percentage-bloc " + (cell === 100 ? 'per-success' : cell < 75 ? 'per-danger' : 'per-info')}> {cell}% </div>
			</div>
		);
	}

	renderList(){
		const { lead } = this.props;

		return(
			<div className="table-list-lead">
				<BootstrapTable ref='table' data={lead.list} options={this.options} pagination>
		            <TableHeaderColumn dataField='company' isKey={true} dataSort={true} dataFormat={this.companyFormatter}> Raison sociale </TableHeaderColumn>
		            <TableHeaderColumn dataField='region' dataSort={true} dataFormat={this.regionFormatter}> Région </TableHeaderColumn>
		            <TableHeaderColumn dataField='cp' dataSort={true} dataFormat={this.cpFormatter}> CP </TableHeaderColumn>
		            <TableHeaderColumn dataField='specialties' dataSort={true} dataFormat={this.specialtiesFormatter} > Compétences </TableHeaderColumn>
		            <TableHeaderColumn dataField='created_at' dataSort={true} sortFunc={ this.sortDates } > Candidature </TableHeaderColumn>
		            <TableHeaderColumn dataField='status' dataSort={true} dataFormat={this.statusFormatter}> Statut </TableHeaderColumn>
		            <TableHeaderColumn dataField='percentage' dataSort={true} dataFormat={this.percentageFormatter}> Pourcentage </TableHeaderColumn>
		        </BootstrapTable>
	        </div>
		)
	}

	sortDates (a, b, order) {
		const date_a = a.created_at.split('/').map(number => parseInt(number, 10))
		const date_b = b.created_at.split('/').map(number => parseInt(number, 10))

		const orderNumber = order === 'desc' ? 1 : -1

		for (let i = 2; i >= 0; i--) {
			if (date_a[i] < date_b[i]) return orderNumber
			else if (date_a[i] > date_b[i]) return -1 * orderNumber
		}

		return 0
	}

	renderTunnel(){
		const { lead } = this.props;
		var tunnel = {	CA: Array(),
    		RV: Array(),
    		PA: Array(),
    		W: Array(),
    		A: Array(),
    		R: Array(),
    		VF: Array(),
		}

		lead.list.map(function(item) {
			var status = item.status;
			if (status === "RV" && item.rdv)
				status = "VF";

			tunnel[status].push(
				<tr key={item.id}>
					<td key={item.id}>
						<Link to={"/manager/prestataire/"+item.id} ><div className="company">{capitalizeFirstLetter(item.company)}</div></Link>
						<Link to={"/manager/prestataire/"+item.id} ><div className="name">
							{capitalizeFirstLetter(item.first_name)} {capitalizeFirstLetter(item.last_name)}</div>
						</Link>
					</td>
					<td>
						<div className="specialties-formatter">
						    {renderIconSpecialties(item.specialties)}
						</div>
					</td>
				</tr>
			)
		}.bind(this));

		return(
			<Row className="tunnel-lead">
				<Col>
					<div className="table-tunnel-lead">
						<Table>
							<tbody>
								<tr>
									<th> Candidatures en cours </th>
									<th> </th>
								</tr>
								{tunnel['CA','W']}
							</tbody>
						</Table>
					</div>
				</Col>

				<Col>
					<div className="table-tunnel-lead">
						<Table>
							<tbody>
								<tr>
									<th> En attente analyse </th>
									<th> </th>
								</tr>
								{tunnel['PA']}
							</tbody>
						</Table>
					</div>
				</Col>

				<Col>
					<div className="table-tunnel-lead">
						<Table>
							<tbody>
								<tr>
									<th> Rendez-vous </th>
									<th> </th>
								</tr>
								{tunnel['RV']}
							</tbody>
						</Table>
					</div>
				</Col>

				<Col>
					<div className="table-tunnel-lead">
						<Table>
							<tbody>
								<tr>
									<th> A finaliser </th>
									<th> </th>
								</tr>
								{tunnel['VF']}
							</tbody>
						</Table>
					</div>
				</Col>

			</Row>
		)

	}

	renderResponsive(){
		const { lead } = this.props

		const tr = lead.list.map(function(item) {
			if((item.status === this.state.responsive && !item.rdv) || (this.state.responsive === "VF" && item.status === "RV" && item.rdv)){
				return (
					<tr key={item.id}>
						<td key={item.id}>
							<div>
								<Link to={"/manager/prestataire/"+item.id} ><div className="company">{item.company}</div></Link>
								<Link to={"/manager/prestataire/"+item.id} ><div className="name">{item.first_name} {item.last_name}</div></Link>
							</div>
							<div>
								<div className="name">{item.region_name}</div>
								<div className="name">{item.list_departments.join('-')} </div>
								<div className="name">{renderIconSpecialties(item.specialties)}</div>
							</div>
						</td>
						<td>

						</td>
					</tr>
				)
			}
		}.bind(this));

		return(
			<Row className="tunnel-lead">
				<Col>
					<div className="table-tunnel-lead">
						<Table>

							<tbody>
								<tr>
									<th> Leads </th>
									<th> </th>
								</tr>

								{tr}

							</tbody>
						</Table>

					</div>
				</Col>
			</Row>
		)
	}

	renderLeads(){

		if(this.state.display === "list"){
			return (
				this.renderList()
			)
		}
		if(this.state.display === "tunnel"){
			return (
				this.renderTunnel()
			)
		}
		if(this.state.display === "responsive"){
			return (
				this.renderResponsive()
			)
		}
	}

	changeResponsiveStatus(e){
		this.setState({responsive: e.target.value});
		console.log(e.target.value)
	}

	renderHeader(){
		const { lead } = this.props

		if(this.state.display === "responsive"){

			return(
				<Col>

        			<div className="leads-total"> {lead.list.length} Candidatures </div>

        			<div className="select-status">
	        			<select onChange={(event) => this.changeResponsiveStatus(event)}>
	        				<option value="CA">Candidature</option>
	        				<option value="PA">Pré-analyse</option>
	        				<option value="RV">Rendez-vous</option>
	        				<option value="VF">Validation finale</option>
	        			</select>
        			</div>

        		</Col>
			)

		}else{
			return(
				<Col>

        			<div className="leads-total"> {lead.list.length} Candidatures </div>

        			<div className={"leads-type " + (this.state.display === "tunnel" ? 'type-active' : '') } onClick={() => this.changeDisplay('tunnel')}>
        				<IconFilter /> Tunnel
        			</div>
        			<div className={"leads-type " + (this.state.display === "list" ? 'type-active' : '') } onClick={() => this.changeDisplay('list')}>
        				<IconList /> Liste
        			</div>

        			{this.state.display === "list" &&
            			<div className="leads-refusal">
            				<label><input type="checkbox" onChange={(event) => this.leadRefusal(event)}/> Voir les candidatures non retenues</label>
            			</div>
        			}

        		</Col>
	          )
		}
	}

    render() {
    	const { lead } = this.props;

    	return (
            <div>

            	<div className="leads-header">
	            	<Row>

	            		{this.renderHeader()}

	            	</Row>
            	</div>

            	{lead.fulfilled &&
            		this.renderLeads()
            	}

            	{lead.pending &&
            		<Loader />
            	}

            </div>
        )
    }
}


export default LeadList



// WEBPACK FOOTER //
// ./src/lead/components/LeadList.js